<template>
  <div class="row">
    <div class="col-lg-6 col-sm-12 col-xs-12" v-for="input in inputs" :key="input.key">
      <Input v-model="projectDataLocal.salesOrderInformation[input.key]" :placeholder="input.name" :viewMode="!canEdit" />
    </div>
  </div>
</template>

<script>
import Input from '../../../../common/input';

export default {
  title: 'SalesOrderInformation',
  components: {
    Input,
  },
  props: {
    projectData: {
      type: Object,
      default: () => {},
    },
    canEdit: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      inputs: [
        {
          name: 'Document number',
          key: 'documentNumber',
        },
        {
          name: 'Customer number',
          key: 'customerNumber',
        },
        {
          name: 'Name',
          key: 'name',
        },
        {
          name: 'Street',
          key: 'street',
        },
        {
          name: 'ZIP Code',
          key: 'zipCode',
        },
        {
          name: 'City',
          key: 'city',
        },
        {
          name: 'Country',
          key: 'country',
        },
        {
          name: 'Project No',
          key: 'projectNumber',
        },
        {
          name: 'customer_no_for_delivery',
          key: 'customerNumberDelivery',
        },
        {
          name: 'Name for delivery',
          key: 'nameDelivery',
        },
        {
          name: 'Street (delivery address)',
          key: 'streetDelivery',
        },
        {
          name: 'ZIP Code (delivery address)',
          key: 'zipCodeDelivery',
        },
        {
          name: 'City (delivery address)',
          key: 'cityDelivery',
        },
        {
          name: 'Country (delivery address)',
          key: 'countryDelivery',
        },
      ],
    };
  },
  computed: {
    projectDataLocal: {
      get: function () {
        return this.projectData;
      },
      set: function (value) {
        this.$emit('projectData', value);
      },
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss"></style>
